module.exports = __webpack_public_path__ + "img/mockup-keller.09fdfb2.jpg";